import type { FC } from "react"

import type { TransferFormPallet } from "../../types"

import { TransferFormPalletTable } from "./TransferFormPalletTable"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import type { WarehouseArea } from "@/graphql/codegen/graphql"

interface TransferFormProductRowDetailsProps {
  pallets: TransferFormPallet[]
  uomName: string
  targetWarehouseArea?: WarehouseArea
  readOnly?: boolean
  onPalletOverride: (palletReferenceNumber: number) => void
  onPalletRemove: (palletReferenceNumber: number) => void
  onLotRemove: (rawInventoryId: string) => void
}

export const TransferFormProductRowDetails: FC<TransferFormProductRowDetailsProps> = ({
  pallets,
  uomName,
  targetWarehouseArea,
  readOnly = false,
  onPalletOverride,
  onPalletRemove,
  onLotRemove,
}) => {
  if (!pallets.length) {
    return (
      <div className='p-6'>
        <InformationMissingAlert title="Pallets haven't been selected yet. Selected pallet details will appear here." />
      </div>
    )
  }

  return (
    <div className='p-6'>
      <TransferFormPalletTable
        pallets={pallets}
        uomName={uomName}
        targetWarehouseArea={targetWarehouseArea}
        readOnly={readOnly}
        onPalletOverride={onPalletOverride}
        onPalletRemove={onPalletRemove}
        onLotRemove={onLotRemove}
      />
    </div>
  )
}
